import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { LoginPayload, LoginResponse } from '../../../models/user.model';
import {
  ChangeMyPasswordPayload,
  MyProfileDto,
  UpdateMyProfilePayload,
} from '../../../models/auth/my-profile.model';

@Injectable({
  providedIn: 'root',
})
export class ApiAuthService {
  private baseUrl = environment.apiPrivateUrl;
  private cookieService = inject(CookieService);
  private apiMethodService = inject(ApiMethodService);
  private http = inject(HttpClient);

  getMyProfile(): Observable<MyProfileDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<MyProfileDto>(
      '/Auth/getMyProfile',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getMyProfile',
        token,
        headerOnly: false,
      },
    );
  }

  updateMyProfile(payload: UpdateMyProfilePayload): Observable<{ isSuccess?: boolean; message?: string }> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<{ isSuccess?: boolean; message?: string }>(
      '/Auth/updateMyProfile',
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'updateMyProfile',
        token,
        headerOnly: false,
        body: payload,
      },
    );
  }

  changeMyPassword(payload: ChangeMyPasswordPayload): Observable<{ isSuccess?: boolean; message?: string }> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<{ isSuccess?: boolean; message?: string }>(
      '/Auth/changeMyPassword',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'changeMyPassword',
        token,
        headerOnly: false,
        body: payload,
      },
    );
  }

  setFirstPassword(payload: LoginPayload): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      `${this.baseUrl}/Auth/setFirstPassword`,
      payload,
      { withCredentials: true },
    );
  }

  logout(): Observable<{ isSuccess?: boolean; message?: string }> {
    const token = this.cookieService.get('token');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.post<{ isSuccess?: boolean; message?: string }>(
      `${this.baseUrl}/Auth/Logout`,
      {},
      { headers, withCredentials: true },
    );
  }

  /** ต่ออายุ session ฝั่ง API ขณะผู้ใช้ยังใช้งานอยู่ + คืนค่า idle timeout ปัจจุบัน */
  sessionHeartbeat(): Observable<{ idleTimeoutMinutes: number }> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<{ idleTimeoutMinutes: number }>(
      '/Auth/sessionHeartbeat',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'sessionHeartbeat',
        token,
        headerOnly: false,
      },
    );
  }
}
